export const CustomerInvoiceColumns = [
  {
    id: "invoice_actions",
    type: "edit",
    title: "Actions",
  },
  {
    id: "name",
    title: "Name",
  },
  {
    id: "qty",
    title: "Quantity",
  },
  {
    id: "price",
    title: "Price",
  },
  {
    id: "amount",
    title: "Total",
  },
];
